<ng-container *ngIf="isMobile else desktopTemplate">
	<div class="business-pin-mobile-container flex flex-wrap flex-col min-h-[calc(100vh_-_16px)]">
		<div class="business-pin-mobile-wrapper pt-[55px] h-[194px]">
			<div class="p-l-20 p-r-20" nz-row nzAlign="middle" nzJustify="space-between">
				<div class="navigation-button">
					<app-back-navigation-button
						(goBack)="goBack()"
						[buttonName]="backButton">
					</app-back-navigation-button>

				</div>
			</div>
			<div class="p-l-20 p-r-20 time-line-wrapper mt-[21px]">
				<app-time-line-details
					[description]="description"
					[title]="title">
				</app-time-line-details>
			</div>
		</div>
		<div class="form-container bg-[#FFFFFF] py-[10px] px-[14px] min-h-[calc(100vh_-_172px)]">
			<app-need-help-mobile></app-need-help-mobile>
		</div>
	</div>
</ng-container>
<ng-template #desktopTemplate>
	<div class="form-container bg-[#FFFFFF] py-[10px] px-[14px] min-h-[calc(100vh_-_172px)]">
		<app-need-help-desktop></app-need-help-desktop>
	</div>
</ng-template>


